import React from "react"
import { useTooltip } from "./ShadeSelectorTooltip.utils"
import { tooltip, tooltipContent, tooltipArrow } from "./ShadeSelector.css"

type Props = {
  text: string
  children: React.ReactNode
}

export const ShadeSelectorTooltip: React.FC<Props> = ({ text, children }) => {
  const {
    buttonRef,
    tooltipRef,
    handleMouseEnter,
    handleMouseLeave,
    showTooltip,
    tooltipPosition,
  } = useTooltip()

  return (
    <div id="shadepicker-tooltip" data-testid="shadepicker-tooltip">
      <button
        type="button"
        ref={buttonRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </button>
      <div
        className={tooltip}
        ref={tooltipRef}
        style={{
          left: `${tooltipPosition.left}px`,
          top: `${tooltipPosition.top}px`,
          opacity: showTooltip ? 1 : 0,
          pointerEvents: "none",
        }}
      >
        <div className={tooltipContent}>{text}</div>
        <div className={tooltipArrow} />
      </div>
    </div>
  )
}
